module.exports = __webpack_public_path__ + "static/media/faq1.753d3b63.png";